import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from './app.settings';
import { Router, NavigationEnd } from '@angular/router';
import { AppService } from './app.service';
import { AppConfig } from './app.config';
import { AuthenticationService } from './services/AuthenticationService';
import { LoggingService } from './services/LoggingService';

@Component({ standalone:false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
   
  constructor(public appSettings:AppSettings, public router:Router, private appService:AppService, private appConfig:AppConfig, private authService:AuthenticationService, private logger:LoggingService) {
    //first we need to verify if we already have required data in session storage to init the app coming from a refresh
    var jsonUser=sessionStorage.getItem('currentUser');
    var accessToken=this.appConfig.accessToken;
    if(jsonUser&&accessToken){
      this.appService.init();
    }
    //now we need to add event listener for local storage events to achieve session data sharing between browser tabs
    window.addEventListener('storage',(event)=>{
      var jsonUser=sessionStorage.getItem('currentUser');
      var jsonCustomer=sessionStorage.getItem('currentCustomer');
      var jsonCustomerContext=sessionStorage.getItem('currentCustomerContext');
      var accessToken=this.appConfig.accessToken;
      var credentials:{u:string,c:string,cc:string,at:string}|undefined=undefined;
      if(jsonUser&&accessToken) credentials={u:jsonUser,c:jsonCustomer ?? '',cc:jsonCustomerContext ?? '',at:accessToken};
      if(event.key === 'REQUESTING_SHARED_CREDENTIALS' && event.newValue){
        this.logger.log('Requesting shared credentials')
        window.localStorage.setItem('CREDENTIALS_SHARING', JSON.stringify(credentials))
        window.localStorage.removeItem('CREDENTIALS_SHARING')
      }
      if(event.key === 'CREDENTIALS_SHARING' && !credentials && event.newValue){
        //the following looks weird, but we need to check for newValue existence, because in some browsers (Firefox) the event is also triggered when the key is removed
        const newValue=event.newValue;
        if(newValue){
          //set in session storage if not already existing
          credentials=JSON.parse(newValue) as {u:string,c:string,cc:string,at:string};
          window.sessionStorage.setItem('currentUser', credentials.u);
          if(credentials.c) window.sessionStorage.setItem('currentCustomer', credentials.c); //optional
          if(credentials.cc) window.sessionStorage.setItem('currentCustomerContext', credentials.cc); //optional
          this.appConfig.accessToken=credentials.at;
          this.appService.init();
        }

      }
      if(event.key === 'CREDENTIALS_FLUSH' && event.newValue && credentials && event.newValue===this.authService.currentUserValue?.email){
        this.authService.logout();
      }
    });
    window.localStorage.setItem('REQUESTING_SHARED_CREDENTIALS', Date.now().toString())
    window.localStorage.removeItem('REQUESTING_SHARED_CREDENTIALS')
  }

  ngAfterViewInit(){ 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {   
        setTimeout(() => {
          window.scrollTo(0,0);
        }); 
      }            
    });    
  }

  ngOnDestroy(){
    this.logger.log('App component destroyed');
  }

  get settings(){
    return this.appSettings.settings;  
  }
}
